module.exports = __webpack_public_path__ + "assets/56ee74b4fc956513d169993b88805ddb.mp3";